import { useEffect, useState } from 'react';
import { currentRoute, onRouteChange, type Route } from './lib/router.js';

/** The current route, re-rendered on navigation and on back/forward. */
export function useRoute(): Route {
  const [route, setRoute] = useState<Route>(() => currentRoute());
  useEffect(() => onRouteChange(setRoute), []);
  return route;
}
